import { render, staticRenderFns } from "./tip_switch.vue?vue&type=template&id=aa882fea&"
import script from "./tip_switch.vue?vue&type=script&lang=js&"
export * from "./tip_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports